import styled from 'styled-components';
import ButtonCompactPrimary from './Primary';

const ButtonCompactSecondary = styled(ButtonCompactPrimary)`
  background-color: ${props => props.theme.colors.secondary};
  color: #000;
  margin: ${props => (props.margin || null)}; 
`;

export default ButtonCompactSecondary;



// WEBPACK FOOTER //
// ./src/components/atoms/buttons/compact/Secondary.js